var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9918C10.3432 14.9918 9 16.335 9 17.9918V23.9918H15V17.9918C15 16.335 13.6568 14.9918 12 14.9918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.9922V23.9922H21C22.6568 23.9922 24 22.649 24 20.9922V11.8712C24.0002 11.3517 23.7983 10.8525 23.437 10.4792L14.939 1.29218C13.4396 -0.330162 10.9089 -0.429771 9.28655 1.06967C9.20949 1.14092 9.13523 1.21512 9.06403 1.29218L0.581016 10.4762C0.208734 10.851 -0.000140554 11.3579 7.09607e-08 11.8862V20.9922C7.09607e-08 22.649 1.34316 23.9922 3 23.9922H6.99998V17.9922C7.01869 15.2654 9.22027 13.0386 11.8784 12.9745C14.6255 12.9082 16.9791 15.1729 17 17.9922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9918C10.3432 14.9918 9 16.335 9 17.9918V23.9918H15V17.9918C15 16.335 13.6568 14.9918 12 14.9918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home-white.3b03d367844ff05c62570aa4e7ee75da.svg";
export { ForwardRef as ReactComponent };